import Helper from './Helper';

class MSituation {
  constructor(ptSituation) {
    this.element = document.createElement('details');
    this.element.classList.add('m-situation');

    this.ptSituation = ptSituation;
    this.situationNumber = ptSituation['siri:SituationNumber'];
    this.startTime = ptSituation['siri:ValidityPeriod']?.['siri:StartTime'];
    this.endTime = ptSituation['siri:ValidityPeriod']?.['siri:EndTime'];

    this.dateToLocaleString = (date) => (new Date(date)).toLocaleString('de-DE', {
      dateStyle: 'long',
    });

    this.updateElement();
  }

  updateElement() {
    const { ptSituation } = this;

    const summary = ptSituation['siri:Summary'];
    const description = ptSituation['siri:Description'];
    const detail = ptSituation['siri:Detail'];
    let validityPeriod;
    if (this.startTime && this.endTime) {
      const validityPeriodStartTime = this.dateToLocaleString(ptSituation['siri:ValidityPeriod']?.['siri:StartTime']);
      const validityPeriodEndTime = this.dateToLocaleString(ptSituation['siri:ValidityPeriod']?.['siri:EndTime']);
      validityPeriod = `Gültig von ${validityPeriodStartTime} bis ${validityPeriodEndTime}`;
    }
    const participant = ptSituation['siri:ParticipantRef'] ?? null;

    let html = '';
    html += `
      <summary>${Helper.escapeHtml(summary)}${description ? ` (${Helper.escapeHtml(description)})` : ''}</summary>
      <div>
        <div class="m-situation__content"></div>
        <div class="m-situation__info">
          ${validityPeriod ? `<small>${validityPeriod}</small>` : ''}
          ${participant ? `<small>(${Helper.escapeHtml(participant)})</small>` : ''}
        </div>
      </div>
    `;
    this.element.innerHTML = html;
    // siri:Detail contains HTML (e.g. <div>…</div>)
    if (detail !== summary) {
      this.element.querySelector('.m-situation__content').append(Helper.sanitizeHtml(detail));
    }
  }
}

export default MSituation;
